import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CONFIRMATION } from 'app/main/pages/general-editor-tabs/recipients-tab/recipient-data';
import { Confirmation } from 'app/main/pages/general-editor-tabs/recipients-tab/recipient-tab.dto';
import { IField } from 'app/main/pages/settings/documenttype/document-type-settings-modal/document-type-settings.dto';
import { TranslocoRootModule } from 'app/transloco-root.module';
import { FieldActionEvent } from '../dynamic-field.component';

@Component({
  selector: 'app-sender-confirmation-type-field',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoRootModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './sender-confirmation-type-field.component.html',
  styleUrl: './sender-confirmation-type-field.component.scss'
})
export class SenderConfirmationTypeFieldComponent {
  @Input() formGroup!: FormGroup;
  @Output() actionEmit = new EventEmitter<FieldActionEvent>();
  @Input() canEdit: boolean = true;
  @Input()
  set field(value: IField) {
    this._field = structuredClone(value);
  }

  get field(): IField {
    return this._field;
  }


  public _field: IField;
  public confirmation: Confirmation[] = CONFIRMATION();


  onChangeConfirmationType($event: Confirmation): void {
    this.actionEmit.emit({action: 'onChangeConfirmationType', data: $event.value });
  }
}
